/*
*###############################################################################
*Module Name                   : TicketMaster.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 1st 2022, 10:14:01 am          #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'
import { Text, Numeric } from "../../../framework/validators/TextValidation"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import ReactPaginate from 'react-paginate';
import DPDropDown from 'framework/components/DPDropDown'

const TicketMasterContent = ({
    CodeValue,
    CodeonChange,
    DescValue,
    DescOnChange,
    disabled,
    bundle,
    setBundle,
    allBundle,
    SwonChange,
    ActiveSw,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    onButtonClick,
    btnDisable,
    gridData,
    autoCode,
    SearchDisable,
    menuCode,
    SetGridData,
    DataRow,
    currentPage,
    setCurrentPage,
    redeemToDate,
    redeemFromDate,
    billValue,
    ticketValue,
    setRedeemToDate,
    setRedeemFromDate,
    setBillValue,
    setTicketValue,
    setBillValueOnBlur,
    setTicketValueOnBlur,
    setRedeemBillValueFrom,
    setRedeemBillValueFromOnBlur,
    setRedeemBillValueTo,
    setRedeemBillValueToOnBlur,
    redeemBillValueFrom,
    redeemBillValueTo
}) => {
    //*** useState to save table data */
    const [Datatablesub, SetDatatablesub] = useState([])
    const [groupFilter, SetGroupFilter] = useState('a')
    const [postsPerPage] = useState(10)    

    //*** End of useStates */

    const ApiURL = window.Links.ApiURL


    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };


    async function tog_backdrop() {
        modelTrigger();
    }

    /**
    * @description This function is used to change the value of particular field in particular row.
    * @param {string} value - value of the row.
    * @param {string} id - id of the row.
    * @param {string} element - element of the row.
 */

    const changeRowValueChanges = (value, id, element) => {
        const objectIndex = DataRow.findIndex(obj => obj.id === id);
        const newObject = { ...DataRow[objectIndex], [element]: value };
        SetGridData(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = newObject;
            return newDataRow;
        });
    };

    /**
    * @description This function is used to change the value of complete row.
    * @param {JSON} row - row of the table.
    * @param {string} id - id of the row.
 */

    function handleObjectChange(row, id) {
        const objectIndex = DataRow.findIndex(obj => obj.id === id);
        SetGridData(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = row;
            return newDataRow;
        });
    }

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    function handleAddRowNested() {
        const modifiedRows = [...DataRow]

        const findEmptyRow = modifiedRows.findIndex(obj => obj.lineDesc === "")

        if (findEmptyRow != -1) {
            return
        }

        modifiedRows.push({
            id: modifiedRows.length + 1,
            lineNo: modifiedRows.length + 1,
            lineDesc: "",
            lineBold: false,
            lineUnderline: false,

        })

        const modifiedIdList = modifiedRows.map((item, index) => {
            item.lineNo = index + 1
            item.id = index + 1
            return item
        })

        SetGridData(modifiedIdList)
    }


    function handleRemoveRow(id) {

        const modifiedRows = [...DataRow]
        const index = modifiedRows.findIndex(obj => obj.id === id)
        modifiedRows.splice(index, 1)

        if (modifiedRows.length == 0) {
            modifiedRows.push({
                id: modifiedRows.length + 1,
                lineNo: modifiedRows.length + 1,
                lineDesc: "",
                lineBold: false,
                lineUnderline: false,

            })
        }

        const modifiedIdList = modifiedRows.map((item, index) => {
            item.lineNo = index + 1
            item.id = index + 1
            return item
        })

        SetGridData(modifiedIdList)
    }

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBoxButton
                                    rowClass="mb-4-sm"
                                    labelText="Code *"
                                    textType="text"
                                    maxLength="5"
                                    value={CodeValue}
                                    onChange={CodeonChange}
                                    onBlur={CodeOnBlur}
                                    disabled={disabled == true ? disabled : disabledCode}
                                    onButtonClick={onButtonClick}
                                    btnDisable={disabled == true ? disabled : btnDisable}
                                    placeholder={autoCode}

                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Description *"
                                    textType="text"
                                    maxLength="50"
                                    value={DescValue}
                                    onChange={DescOnChange}
                                    disabled={disabled}
                                />
                                <Row>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Active
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SwonChange}
                                            checked={ActiveSw}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Ticket Value"
                                    textType="text"
                                    textAlign={"right"}
                                    maxLength="50"
                                    value={ticketValue}
                                    onChange={setTicketValue}
                                    onBlur={setTicketValueOnBlur}
                                    disabled={disabled ? true : parseFloat(billValue) > 0 ? true : false}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Discount Percentage"
                                    textType="text"
                                    textAlign={"right"}
                                    maxLength="50"
                                    value={billValue}
                                    onChange={setBillValue}
                                    onBlur={setBillValueOnBlur}
                                    disabled={disabled ? true : parseFloat(ticketValue) > 0 ? true : false}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Redeem From"
                                    textType="date"
                                    maxLength="50"
                                    value={redeemFromDate}
                                    onChange={setRedeemFromDate}
                                    disabled={disabled}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Redeem To"
                                    textType="date"
                                    maxLength="50"
                                    value={redeemToDate}
                                    onChange={setRedeemToDate}
                                    disabled={disabled}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Redeem Bill Value From"
                                    textType="text"
                                    textAlign={"right"}
                                    maxLength="50"
                                    value={redeemBillValueFrom}
                                    onChange={setRedeemBillValueFrom}
                                    onBlur={setRedeemBillValueFromOnBlur}
                                    disabled={disabled}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Redeem Bill Value To"
                                    textType="text"
                                    textAlign={"right"}
                                    maxLength="50"
                                    value={redeemBillValueTo}
                                    onChange={setRedeemBillValueTo}
                                    onBlur={setRedeemBillValueToOnBlur}
                                    disabled={disabled}
                                />
                                <DPDropDown
                                    labelText={"Item Bundle"}
                                    optionGroup={allBundle}
                                    selectedGroup={bundle}
                                    onChange={setBundle}
                                    disabled={disabled}
                                />
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm">
                                <Button
                                    onClick={() => {
                                        tog_backdrop()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={SearchDisable}
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>
                            </Col>
                            <DPSearchBoxDynamic
                                searchData={Datatablesub}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"TICKET"}
                                MenuCode={menuCode}
                                KeyVal={'TIC'}
                                searchBy={'PTICK_CODE'}
                                FilterStr={groupFilter}
                            />
                        </Row>
                        <Row className='mt-3'>
                            <Col sm={12} md={6} className="mb-4-sm">
                                <table id="TicketDet">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Line No</th>
                                            <th>Line Description</th>
                                            <th style={{ textAlign: 'center' }}>Bold</th>
                                            <th style={{ textAlign: 'center' }}>Underline</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPosts.map((formRow, index) => (
                                            <TableRow
                                                key={index}
                                                FormRow={formRow}
                                                Disable={disabled}
                                                RemoveRow={handleRemoveRow}
                                                changeRowValueChanges={changeRowValueChanges}
                                                handleObjectChange={handleObjectChange}
                                            />
                                        )
                                        )}
                                    </tbody>
                                </table>
                                <Row sm={12} md={12} className="mb-4-sm mt-2">
                                    <Col>
                                        <Button
                                            disabled={disabled}
                                            onClick={() => {
                                                handleAddRowNested()
                                            }}
                                            color="success"
                                            className="mt-1"
                                            size='sm'
                                        >
                                            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                                        </Button>
                                    </Col>
                                    <Col className='mt-1'>
                                        <ReactPaginate
                                            previousLabel={'Previous'}
                                            nextLabel={'Next'}
                                            breakLabel={'...'}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            pageCount={Math.ceil(DataRow.length / postsPerPage)}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            forcePage={currentPage - 1}
                                            renderOnZeroPageCount={null}
                                            activeClassName={'active'}
                                            activeLinkClassName={'page-link'}
                                            containerClassName={'pagination justify-content-start pagination-sm'}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

const TableRow = ({ FormRow, Disable, Key, RemoveRow, changeRowValueChanges, handleObjectChange }) => {

    return (
        <tr key={FormRow.id}>
            <td style={{ width: "80px" }}>
                <DPTextBoxforgrid
                    id={"lineNo" + Key}
                    rowClass="mb-2-sm"
                    labelText="Code *"
                    textType="text"
                    maxLength="5"
                    value={FormRow.lineNo}
                    disabled={true}
                />
            </td>
            <td style={{ width: "200px" }}>
                <DPTextBoxforgrid
                    id={"lineDesc" + Key}
                    rowClass="mb-4-sm"
                    labelText="Code *"
                    textType="text"
                    maxLength="150"
                    value={FormRow.lineDesc}
                    onChange={(e) => {
                        var val1 = Text(e.target, 50, true, true, "any", true)
                        if (val1 != "") {
                            changeRowValueChanges(val1, FormRow.id, "lineDesc")
                        } else {
                            changeRowValueChanges('', FormRow.id, "lineDesc")
                        }
                    }}
                    disabled={Disable}
                />
            </td>
            <td style={{ width: "80px", textAlign: 'center' }}>
                <DPSwitch
                    id={"lineBold" + FormRow.id}
                    checked={FormRow.lineBold}
                    onChange={(e) => {
                        changeRowValueChanges(e, FormRow.id, "lineBold")
                    }}
                    disabled={Disable}

                />
            </td>
            <td style={{ width: "80px", textAlign: 'center' }}>
                <DPSwitch
                    id={"lineUnderline" + Key}
                    checked={FormRow.lineUnderline}
                    onChange={(e) => {
                        changeRowValueChanges(e, FormRow.id, "lineUnderline")
                    }}
                    disabled={Disable}

                />
            </td>
            <td style={{ width: "30px" }}>
                <Button
                    outline
                    color="danger"
                    id={"btnFaxDelete" + Key}
                    onClick={e => {
                        RemoveRow(FormRow.id)
                    }}
                    size="sm"
                >
                    <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
                </Button>
            </td>
        </tr>
    )

}



export default TicketMasterContent